import { b2x } from '@b2x/react/src';

import { ComponentWrapper } from './ComponentWrapper';
import { SocialFeedAContentType } from './contentTypes';
import { Icon } from './Icon';

export const SocialFeedA = ({ header, options, socialFeed }: SocialFeedAContentType) => {
  b2x.addScript({ async: true, id: 'elfsight', src: 'https://elfsightcdn.com/platform.js' });

  return (
    <ComponentWrapper classNames="social-feed-a" options={{ ...options, container: undefined }}>
      <b2x.Container>
        <b2x.Div marginBottom={{ lg: 5, xs: 4 }} textAlign={'center'}>
          {header?.preTitle && <p className="h3">{header.preTitle}</p>}
          <b2x.Div alignItems={'center'} display={'flex'} gap={3} justifyContent={'center'}>
            <Icon name="instagram" size={50} />
            {header?.logo && <b2x.AssetV2 {...header.logo} fluid />}
          </b2x.Div>
        </b2x.Div>
      </b2x.Container>
      <b2x.Div>{b2x.formatHtml(socialFeed?.element)}</b2x.Div>
    </ComponentWrapper>
  );
};
